var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42_71)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 50,
    height: 50,
    rx: 19,
    fill: "#4D8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4821 24.6429L30.6518 25.1875L32.3929 24.6696V23.4554C32.3929 21.3929 30.6518 19.7411 28.5714 19.7411C26.5 19.7411 24.75 21.3839 24.75 23.4286V28.9643C24.75 29.4732 24.3393 29.875 23.8393 29.875C23.3393 29.875 22.9286 29.4732 22.9286 28.9643V26.625H20C20 28.9732 20 29 20 29C20 31.1161 21.7143 32.8304 23.8304 32.8304C25.9286 32.8304 27.6607 31.1429 27.6607 29.0536V23.5893C27.6607 23.0893 28.0714 22.6786 28.5714 22.6786C29.0714 22.6786 29.4821 23.0893 29.4821 23.5893V24.6429ZM34.2143 26.625V29.0804C34.2143 29.5804 33.8036 29.9821 33.3036 29.9821C32.8036 29.9821 32.3929 29.5804 32.3929 29.0804V26.6696L30.6518 27.1875L29.4821 26.6429V29.0357C29.4821 31.1339 31.2054 32.8304 33.3125 32.8304C35.4286 32.8304 37.1429 31.1161 37.1429 29C37.1429 29 37.1429 28.9732 37.1429 26.625H34.2143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42_71",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_71"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_71",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.8d2c9c39e8e8b9d605d8553767bbf4da.svg";
export { ForwardRef as ReactComponent };